import React from "react";
import "../styles/aboutUs.css";
import { Link } from "react-router";
import { useEffect } from "react";
import Testimonials from "../components/testimonials";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div className="mission">
      <div className="main-hero-about">
        <h2>About Us</h2>
        <div className="after-line-aboutus"></div>
      </div>
      {/* mission part */}
      <section className="mission-header">
        <h1 className="mission-title">...And we are on a mission</h1>
        <p className="mission-statement">
          A MISSION TO CHANGE THE OLD PEN AND PAPER WAYS OF THE CONSTRUCTION
          INDUSTRY. WE ARE WORKING TO BRING MODERN TECHNOLOGIES TO CONSTRUCTION
          IN A NO-NONSENSE, SIMPLE AND EASY-TO-USE WAY.
        </p>
      </section>
      <section className="about-section">
        <div className="about-sub-section">
          <h2 className="about-title">
            Lets Build, the future of construction
          </h2>

          <div className="about-content">
            <p className="about-paragraph">
              Construction is one of the biggest sectors in the world in terms
              of value, but maybe even bigger in terms of its impact on our
              lives. We live and work in buildings, we travel to work or on
              holiday using infrastructure, we are surrounded by the output of
              this industry.
            </p>

            <p className="about-paragraph">
              But construction is also in trouble, haunted by cost and time
              overruns and poor quality; challenges that can be addressed today
              with modern technologies based on mobile and cloud, together with
              a better understanding of the benefits of data insight and
              decision making.
            </p>

            <p className="about-paragraph">
              Someone needs to bring a new and innovative solution to
              construction, to connect everyone involved in construction
              projects and make their life easier.
            </p>
            <p className="about-paragraph">
              Someone needs to bring a new and innovative solution to
              construction, to connect everyone involved in construction
              projects and make their life easier.
            </p>
            <p className="about-paragraph">
              Someone needs to bring a new and innovative solution to
              construction, to connect everyone involved in construction
              projects and make their life easier.
            </p>
          </div>
        </div>
      </section>
      <section className="stats-section">
        <Testimonials />
      </section>
      
      <div className="cta-section">
        <h3>Want to become a Builder?</h3>
        <Link to="/contact-us" className="cta-button">
          Check our open positions
        </Link>
      </div>
    </div>
  );
};

export default About;
